export default {
	events: {
		'click .js-toggle': 'toggle'
	},

	initialize: function() {
		// references to elements
		var toggleElementClass = this.el.getAttribute('data-toggle-element');

		this.toggleElement = document.querySelector('.' + toggleElementClass) || this.el;
		this.toggleClass = this.el.getAttribute('data-toggle-class') || 'is-open';
	},

	toggle: function(e) {
		e.preventDefault();
		var hidden = this.toggleElement.classList.toggle(this.toggleClass);

		if (!hidden) {
			window.scrollTo(0, this.toggleElement.offsetTop);
		}
	}
};
